import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("jastip_token");
    const stored = localStorage.getItem("jastip_user");
    if (token && stored) {
      try {
        setUser(JSON.parse(stored));
      } catch {}
      // verify token still valid
      api.get("/auth/me").then((r) => {
        setUser(r.data);
        localStorage.setItem("jastip_user", JSON.stringify(r.data));
      }).catch(() => {
        localStorage.removeItem("jastip_token");
        localStorage.removeItem("jastip_user");
        setUser(null);
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = (token, u) => {
    localStorage.setItem("jastip_token", token);
    localStorage.setItem("jastip_user", JSON.stringify(u));
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("jastip_token");
    localStorage.removeItem("jastip_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
